import axios from "axios";
import { useState } from "react";

const useResendVerificationEmail = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const resendEmail = async (email) => {
    setLoading(true);

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/resend-email-verification/`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
          },
        }
      );

      setResponse(result.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data : err.message);
      setResponse(null);
    }

    setLoading(false);
  };

  return { resendEmail, response, error, loading };
};

export default useResendVerificationEmail;
